import gql from 'graphql-tag';

/** 优惠券 */
export const COUPON_FRAGMENT = gql`
  fragment Coupon on Coupon {
    __typename
    id
    createdAt
    state
    enable
    updatedAt
    name
    remarks
    type
    isShareable
    preferentialContent {
      preferentialType
      minimum
      discount
      maximumOffer
      includingDiscountProducts
    }
    validityPeriod {
      type
      startTime
      endTime
      numberOfDays
    }
    totalQuantity
    applicableProduct {
      applicableType
      productIds
    }
    introduce
    promotion {
      id
    }
    activityContent
    activityTime
  }
`;

/** 用户优惠券 */
export const USER_COUPON_FRAGMENT = gql`
  fragment UserCoupon on UserCoupon {
    id
    createdAt
    updatedAt
    claimAt
    useAt
    maturityAt
    maturityType
    isNew
    validFromAt
    coupon {
      ...Coupon
    }
    state
  }
  ${COUPON_FRAGMENT}
`;
